import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { config } from '@app/core/app-config';
import { Channel } from '@app/shared/models/channel';
import { SettingsService } from '@app/shared/services/settings/settings.service';

@Component({
  standalone: false,
  selector: 'sbnb-connect-vrbo-flow',
  templateUrl: './connect-vrbo-flow.component.html',
  styleUrls: ['./connect-vrbo-flow.component.scss'],
})
export class ConnectVrboFlowComponent implements OnInit {
  phase;
  loading: boolean;

  verificationData: any;
  accountData: any;

  // Update account mode
  channelId: string;
  username: string;
  mode: 'new' | 'update' = 'new';
  verificationToken: string;

  constructor(
    private readonly settingsService: SettingsService,
    private readonly route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.channelId = this.route.snapshot.paramMap.get('channel_id');
    this.username = this.route.snapshot.paramMap.get('username');
    this.verificationToken = this.route.snapshot.paramMap.get('verify_id');

    if (this.channelId && this.username) {
      this.mode = 'update';

      if (this.verificationToken) {
        const url = `${config.API_URL}/settings/channels/verification/check/homeaway/${this.verificationToken}`;

        this.initialisePhase2(url);
      } else {
        this.attemptAutoLogin({ username: this.username });
      }
    }
  }

  addNewAccount(data: { username: string; password: string }) {
    this.settingsService
      .addAccount(data.username, data.password, Channel.Vrbo)
      .subscribe((res) => this.handleVrboLoginResponse(res));
  }

  updateAccount(data: { username: string; password: string }) {
    const url = `${config.API_URL}/settings/channels?platform_id=${this.channelId}&platform=homeaway`;

    this.settingsService
      .updateAccount(url, data.username, data.password, Channel.Vrbo)
      .subscribe((res) => this.handleVrboLoginResponse(res));
  }

  attemptAutoLogin(data: { username: string }) {
    this.loading = true;
    const url = `${config.API_URL}/settings/channels?platform_id=${this.channelId}&platform=homeaway`;

    this.settingsService
      .attemptAutoLogin(url, data.username, Channel.Vrbo)
      .subscribe((res) => this.handleVrboLoginResponse(res));
  }

  private handleVrboLoginResponse(res: any) {
    this.loading = false;
    this.accountData = res;

    if (res.error) {
      return;
    }

    switch (res.status) {
      case 'Verification Required':
        this.initialisePhase2(res.status_action_link);
        break;
      case 'Disconnected':
        // Do nothing; the login form will be shown
        break;

      default:
        // Account connected successfully
        this.phase = 3;
        break;
    }
  }

  phase0Complete() {
    this.phase = 1;
  }

  phase1Complete(data: { username: string; password: string }) {
    this.loading = true;

    // Add or update based on mode
    if (this.mode === 'update') {
      this.updateAccount(data);
    } else {
      this.addNewAccount(data);
    }
  }

  initialisePhase2(verifyApiUrl: string) {
    this.phase = 2;

    this.settingsService.getVerifyOptions(verifyApiUrl).subscribe((res) => {
      this.verificationData = res.verification;
    });
  }

  phase2Complete(newAccountData: any) {
    this.phase = 3;
    this.accountData = newAccountData.channel;
  }
}
